module.exports = __webpack_public_path__ + "static/media/plank.a19ca473.jpg";